import { Table, Form, Col, Row, Modal, Button, Select, Checkbox, Tooltip, Input } from 'antd';
import axios from '../../utils/request';
import React, { Component } from 'react';
import { Spinner, Alert } from 'reactstrap';
import { CheckCircleOutlined, ExclamationCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import './CansinoCss.css'


const { Option } = Select;

const columns = [
    {
        title: '背调人员姓名',
        dataIndex: 'name',
        width: 50,
    },
    {
        title: '校验信息',
        dataIndex: 'verifyMsg',
        width: 120,
        render: (text, record) => {
            if (record.verifyStatus) {
                return <div><div style={{ float: 'left', lineHeight: '1.8' }}>{text}</div><CheckCircleOutlined style={{ fontSize: 20, color: '#1890ff' }} /></div>
            } else {
                return <div><div style={{ float: 'left', lineHeight: '1.8' }}>{text}</div><ExclamationCircleOutlined style={{ fontSize: 20, color: 'red' }} /></div>
            }
        }
    },
    {
        title: "提交状态",
        dataIndex: 'sendStatus',
        width: 120,
        render: (text, record) => {
            if (text == 1) {
                return <div><div style={{ float: 'left', lineHeight: '1.8' }}>{record.sendMsg}</div><CheckCircleOutlined style={{ fontSize: 20, color: '#1890ff' }} /></div>
            }
            if (text == 2) {
                return <div><div style={{ float: 'left', lineHeight: '1.8' }}>{record.sendMsg}</div><ExclamationCircleOutlined style={{ fontSize: 20, color: 'red' }} /></div>
            }
        }
    }
];

export class CansinoComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: null,
            applicantList: null,
            productList: null,
            productId: null,
            languageTypeList: null,
            languageproductType: null,
            buttonStatus: false,
            visible: false,
            submitSuccess: true,
            commonParamater: null,
            colorType: "",
            tenantId: null,
            showError: false,
            showErrorMsg: "",
            isUrgent: false,
            createUser: null,
            selectRemark: null,
            selectRemarkBoxStyle:"none",
            otherOptionsList: [],
            remark: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/Cansino/CansinoInit", { params: params })
            .then(res => {
                const data = res.data.data;
                console.log("进入初始化")
                this.setState({ createUser: data.createUser, applicantList: data.cansinoApplicants || [], productList: data.cansinoPackages || [], languageproductType: data.languageTypes || [], otherOptionsList: data.otherOptions || [], remark: data.Remark, isLoading: true, buttonStatus: false });
                console.log("初始化参数获取成功")
            }).catch(reason => {
                const errorMessages = reason?.response?.data?.errorMessages ?? ["获取初始信息失败。"]
                this.setState({ errorMessage: errorMessages });
                this.setState({ isLoading: true });
            })
    }
    render() {
        if (this.state.isLoading) {
            if (this.state.errorMessage != null) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                        <Form onFinish={this.showModal}>
                            <Row>
                                <Col xs={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }}>
                                    <Form.Item label="背调模板" name="productId"
                                        
                                        rules={[
                                            {
                                                required: true,
                                                message: "类型不能为空！"
                                            }
                                        ]}>
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            style={{ width: '100%' }}
                                            onChange={this.selectOnChange}
                                            placeholder="---请选择---">
                                            {this.state.productList.map(function (item, i) {
                                                return <Option key={i} value={item.packageCode}>{item.packageName}</Option>
                                            })}
                                        </Select>

                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 16 }} md={{ span: 16 }} lg={{ span: 16 }}>
                                    <div style={{ lineHeight: "32px", paddingLeft: "10px", display: this.state.selectRemarkBoxStyle, overflow: "hidden" }}>
                                        <ExclamationCircleOutlined style={{ marginTop: "9px", marginRight: "4px", float: "left" }} />
                                        <div style={{ lineHeight: "32px", overflow: "hidden", wordBreak: "break-all" }}>
                                            定制套餐内容包含:{this.state.selectRemark}
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }}>
                                    <Form.Item label="背调类型" name="productType"
                                        initialValue="BGLX0001"
                                        rules={[
                                            {
                                                required: true,
                                                message: "类型不能为空！"
                                            }
                                        ]}

                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            style={{ width: '100%', float: "left" }}
                                            placeholder="---请选择---">
                                            {this.state.languageproductType.map(function (item, i) { return <Option key={i} value={item.key}>{item.value}</Option> })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 16 }} md={{ span: 16 }} lg={{ span: 16 }}>
                                    <div style={{ float: "left", height: "32px", lineHeight: "32px", paddingLeft: "10px" }}>
                                        <ExclamationCircleOutlined style={{ marginTop: "9px", marginRight: "4px", float: "left" }} />
                                        <div style={{ height: "32px", lineHeight: "32px", float: "left" }}>
                                            中英文报告将会在模板单价上增加（50%）
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }}>
                                    <Form.Item label="其他选项" name="otherOptionId"
                                               rules={[
                                                   {
                                                       required: false,
                                                       message: "选项不能为空！"
                                                   }
                                               ]}>
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            style={{ width: '100%' }}
                                            placeholder="---请选择---">
                                            {this.state.otherOptionsList.map(function (item, i) {
                                                return <Option key={i} value={item.packageCode}>{item.packageName}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item label="备注" name="remark">
                                        <Input.TextArea rows={3} placeholder="请输入备注信息" maxLength={500} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item label="是否加急" style={{ paddingLeft: '10px', }}  >
                                        <Form.Item name="IsUrgent" valuePropName="checked" style={{ paddingRight: "10px", float: "left" }}>
                                            <Checkbox onChange={this.handleCheckboxChange}>
                                            </Checkbox>
                                        </Form.Item>
                                        <div style={{ float: "left", height: "32px", lineHeight: "32px" }}>
                                            <ExclamationCircleOutlined style={{ marginTop: "9px", marginRight: "4px", float: "left" }} />
                                            <div style={{ height: "32px", lineHeight: "32px", float: "left" }}>
                                                加急报告将会在模板单价上增加（30%）
                                            </div>
                                        </div>
                                    </Form.Item>

                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                    <Table columns={columns} dataSource={this.state.applicantList} pagination={false} size="small" rowKey="applicantId" />
                                </Col>
                            </Row>
                            <div>
                                <Modal title="发起背调" visible={this.state.visible} okText="确定" cancelText="取消" onOk={this.handleOk} onCancel={this.handleCancel}>
                                    <p>确定发起背调？</p>
                                </Modal>
                            </div>

                            <Row>
                                <Col style={{ textAlign: 'center', paddingTop: '10px', paddingBottom: "10px", width: "100%" }} >

                                    <Button type="primary" disabled={this.state.buttonStatus} htmlType="submit">发起背调</Button>

                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                    <Alert color={this.state.colorType} isOpen={this.state.showError} toggle={this.errDismiss}>{this.state.showErrorMsg}</Alert>
                                </Col>
                            </Row>
                        </Form>

                    </div >)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }

    onFormSubmit = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false, submitSuccess: true });
        }, 2000)
    }

    showModal = values => {
        this.setState({ productId: values.productId, productType: values.productType, otherOptionId: values.otherOptionId, remark: values.remark, visible: true });
    }
    

    handleOk = values => {
        this.setState({ visible: false, buttonStatus: true, });
        const productType = this.state.productType;
        const tenantId = this.state.tenantId;
        const productId = this.state.productId;
        const applicants = this.state.applicantList;
        const isUrgent = this.state.isUrgent;
        const createUser = this.state.createUser;
        console.log(isUrgent);
        let flag = true;
        let countSuccessStatus = 0;
        this.state.applicantList.forEach((item, index) => {
            if (item.verifyStatus) {
                countSuccessStatus++;
            }
        });
        if (countSuccessStatus > 0) {
            let params = {}
            params = {
                tenantId: tenantId,
                productType: productType,
                productId: productId,
                applicants: applicants,
                isUrgent: isUrgent,
                createUser: createUser,
                otherOptionId: this.state.otherOptionId,
                remark: this.state.remark,
            }
            const bodyString = JSON.stringify(params);
            axios.post("/api/Cansino/Index", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                }
            ).then(res => {
                const result = res.data;
                if (result.code == 200) {
                    this.setState({ colorType: "success", buttonStatus: false, applicantList: result.data.cansinoApplicants, showError: true, showErrorMsg: "发起成功，成功失败请查看应聘者提交状态。" });
                } else {
                    this.setState({ buttonStatus: false, colorType: "danger", showError: true, showErrorMsg: result.message });
                }
            }).catch(reason => {
                const errorMessages = reason?.response?.data?.message ?? ["发起背调异常,请联系技术人员。"]
                this.setState({ buttonStatus: false, colorType: "danger", showError: true, showErrorMsg: errorMessages });
            })
        } else {
            this.setState({ buttonStatus: false, colorType: "danger", showError: true, showErrorMsg: "没有可以发起背调的应聘者,请根据数据校验信息完善应聘者信息." });
        }
    }

    errDismiss = () => {
        const isErrorShowing = this.state.showError;
        if (isErrorShowing) {
            this.setState({ showError: false })
        }
        else {
            this.setState({ showError: true })
        }
    };

    handleCancel = (e) => {
        this.setState({ visible: false });
    }
    handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        this.setState({ isUrgent: checked });
    }
    selectOnChange = (value) => {
        let remark = "";
        this.state.productList.map(function (item, i) {
            if (item.packageCode == value) {
                remark = item.remark;
            }
        });
        this.setState({ selectRemark: remark, selectRemarkBoxStyle: "block" });
    }
}